import Confirm from './confirm/container';
import { Ok } from './ok/container';
import styles from './styles.module.scss';

const modalTypes = {
  confirm: <Confirm />,
  ok: <Ok />,
};

type ModalType = keyof typeof modalTypes;

const Renderer = ({ modalType }: { modalType: ModalType }) => {
  return <div className={styles.component}>{modalTypes[modalType]}</div>;
};

export default Renderer;
